import React from "react";

const ReportTypes = () => {
  return (
    <div>
      <h2 className="text-xl font-medium mb-4">Report Types</h2>
      <p>Report types configuration will go here.</p>
    </div>
  );
};

export default ReportTypes;
